module.exports = __webpack_public_path__ + "static/img/bg-win-keduo.c9b8137b.png";